/**
 * Filtros del reporte de tickets (descarga y vista previa). Los ids van
 * como número y 0 es "todos"; las fechas en aaaa-mm-dd. Los nombres solo
 * los usa la descarga para el encabezado del Excel.
 */
export class ParamReporteBean {
    id_estatus: number;
    id_area: number;
    fechaInicio: string;
    fechaFin: string;

    nombreArea: string;
    nombreEstatus: string;
    id_empresaSolicitante: number;
    nombreEmpresa: string;

    regInicial: number;
	regFinal: number;
	regXPagina: number;
	totalPaginas: number;
}
